export default __webpack_public_path__ + "static/lfaulkner-9238abc08dd7d55eb00a1ede546fe24b.jpg";